export const SUPPORTED_FORMATS = ['.obj', '.glb'];

export const EXAMPLE_MODELS = [
  {
    name: 'Roundabout',
    filename: 'roundabout.glb',
    url: 'https://storage.googleapis.com/taman-public/example-models/roundabout.glb',
    description: 'Example roundabout 3D model',
    size: 206000, // 206 KB
  },
  {
    name: 'Roundabout With Textures',
    filename: 'roundabout-textured.glb',
    url: 'https://storage.googleapis.com/taman-public/example-models/roundabout-textured.glb',
    description: 'Example roundabout 3D model with textures',
    size: 31100000, // 31.1 MB
  },
  {
    name: 'Veruda',
    filename: 'veruda.glb',
    url: 'https://storage.googleapis.com/taman-public/example-models/veruda.glb',
    description: 'Example Veruda 3D model',
    size: 177500, // 177.5 KB
  },
  {
    name: 'Zadar coast',
    filename: 'zadar.obj',
    url: 'https://storage.googleapis.com/taman-public/example-models/zadar.obj',
    description: 'Example 3D model of the Zadar waterfront promenade.',
    size: 5760000, // 576 KB
  },
  {
    name: 'Valsaline',
    filename: 'valsaline.obj',
    url: 'https://storage.googleapis.com/taman-public/example-models/valsaline.obj',
    description: 'Example 3D model of the intersection from Veruda and Valsaline streets.',
    size: 2499000, // 249.9 KB
  },
];
